(() => {
  function getCookie(n) {
    const c = document.cookie.split(';').map(s => s.trim()).find(s => s.startsWith(n + '='));
    return c ? decodeURIComponent(c.slice(n.length + 1)) : null;
  }

  let braSize = null;
  try { braSize = JSON.parse(getCookie('jfq_bra_sz') || 'null'); } catch {}
  if (braSize && (!braSize.band || !braSize.cup)) braSize = null;

  let pantySize = null;
  try {
    const _raw = getCookie('jfq_dress_sz') || localStorage.getItem('jfq_dress_sz');
    const _ds = JSON.parse(_raw || 'null');
    pantySize = _ds?.pantySize || null;
  } catch {}

  if (!braSize && !pantySize) return;

  const PANTY_SIZE_ALIASES = {
    XS:  ['XS','EXTRA SMALL','X-SMALL','X SMALL','X-S'],
    S:   ['S','SMALL'],
    M:   ['M','MEDIUM'],
    L:   ['L','LARGE'],
    XL:  ['XL','EXTRA LARGE','X-LARGE','X-L'],
    XXL: ['XXL','EXTRA EXTRA LARGE','2XL','XX-LARGE'],
  };

  // DD↔E and DDD↔F aliases — Shopify groups them as "DD/E" and "DDD/F"
  const CUP_ALIASES = {
    'DD':  ['DD', 'E', 'DD/E'],
    'E':   ['DD', 'E', 'DD/E'],
    'DDD': ['DDD', 'F', 'DDD/F'],
    'F':   ['DDD', 'F', 'DDD/F'],
  };
  function cupForms(cup) { return CUP_ALIASES[cup.toUpperCase()] || [cup]; }
  function sizeForms(band, cup) { return cupForms(cup).map(c => String(band) + c); }

  // Match an input by value attribute first, then by label text (for Shopify GID values)
  function findInput(content, values) {
    const strs = values.map(v => String(v));
    const upper = strs.map(v => v.toUpperCase());
    for (const v of strs) {
      const el = content.querySelector('input[value="' + v + '"]');
      if (el) return el;
    }
    for (const ctrl of content.querySelectorAll('.checkbox-control')) {
      const labelText = (ctrl.querySelector('label')?.textContent || '')
        .replace(/\s*\(\d+\)\s*$/, '').trim().toUpperCase();
      if (upper.includes(labelText)) {
        return ctrl.querySelector('input') || null;
      }
    }
    return null;
  }

  // Detect filter type from input name attribute (filter.v.option.band-size etc.)
  function getFilterType(content) {
    const inp = content.querySelector('input[name]');
    if (!inp) return null;
    const name = inp.name.toLowerCase();
    if (name.includes('band-size') || name.includes('band_size')) return 'band';
    if (name.includes('cup-size') || name.includes('cup_size')) return 'cup';
    if (name === 'filter.v.option.size' || (name.endsWith('.size') && !name.includes('band') && !name.includes('cup'))) return 'size';
    return null;
  }

  // Fallback: get accordion title text
  function getAccordionTitle(acc) {
    const toggle = acc.querySelector('summary .accordion__toggle');
    if (toggle) {
      const titleEl = toggle.firstElementChild;
      if (titleEl) return titleEl.textContent.toLowerCase().trim();
    }
    return (acc.querySelector('summary')?.textContent || '')
      .toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function injectChips(root) {
    (root || document).querySelectorAll('accordion-disclosure').forEach(acc => {
      const content = acc.querySelector('.accordion__content');
      if (!content) return;
      if (content.querySelector('.jfq-pref-chip')) return;

      let type = getFilterType(content);
      if (!type) {
        const title = getAccordionTitle(acc);
        if (title === 'cup size' || title === 'cup') type = 'cup';
        else if (title === 'band size' || title === 'band') type = 'band';
        else if (title === 'size') type = 'size';
      }
      if (!type) return;

      let target = null;
      if (type === 'cup' && braSize)  target = { values: cupForms(braSize.cup), display: braSize.cup };
      else if (type === 'band' && braSize) target = { values: [String(braSize.band)], display: String(braSize.band) };
      else if (type === 'size') {
        // Try bra size first
        if (braSize) {
          const braTarget = { values: sizeForms(braSize.band, braSize.cup), display: braSize.full };
          if (findInput(content, braTarget.values)) target = braTarget;
        }
        // Fall back to panty size if bra size didn't match
        if (!target && pantySize) {
          const ps = pantySize.toUpperCase();
          const psValues = PANTY_SIZE_ALIASES[ps] || [ps];
          if (findInput(content, psValues)) target = { values: psValues, display: pantySize };
        }
      }
      if (!target) return;

      const matchInput = findInput(content, target.values);
      if (!matchInput) return;

      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'jfq-pref-chip';
      chip.style.cssText = [
        'display:inline-flex', 'align-items:center', 'gap:5px',
        'font-size:10.5px', 'letter-spacing:.07em', 'text-transform:uppercase',
        'font-family:inherit', 'line-height:1',
        'color:rgb(89,52,109)', 'border:1px solid rgb(89,52,109)',
        'background:transparent', 'padding:5px 10px', 'border-radius:2px',
        'cursor:pointer', 'margin-bottom:10px', 'opacity:0.8',
        'transition:opacity .15s',
      ].join(';');
      chip.innerHTML = '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" style="flex-shrink:0"><circle cx="5.5" cy="5.5" r="5" stroke="rgb(89,52,109)"/><path d="M3 5.5l1.8 1.8L8 3.5" stroke="rgb(89,52,109)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>Apply my size (' + target.display + ')';
      chip.addEventListener('mouseenter', () => { chip.style.opacity = '1'; });
      chip.addEventListener('mouseleave', () => { chip.style.opacity = '0.8'; });
      chip.addEventListener('click', () => {
        const inp = findInput(content, target.values);
        if (inp && !inp.checked) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
        chip.remove();
      });

      content.insertBefore(chip, content.firstChild);
    });
  }

  injectChips();

  let timer;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(() => injectChips(), 120);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
